import { render } from "./RegisterClient.vue?vue&type=template&id=4f0587ba&scoped=true"
import script from "./RegisterClient.vue?vue&type=script&lang=js"
export * from "./RegisterClient.vue?vue&type=script&lang=js"

import "./RegisterClient.vue?vue&type=style&index=0&id=4f0587ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f0587ba"]])

export default __exports__